import { BaseService } from '@app/core/services/base-service.service';
import { GenericMemberResponsePortalResponseDto } from '@app/core/models/genericMembeResponsePortalResponseDto';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OtherBenefitsDto } from '../model/otherBenefitsDto';

@Injectable({
    providedIn: 'root'
})
export class OtherBenefitsService extends BaseService {

    //#region Constructor
    constructor(http: HttpClient) {
        super(http);
    }
    //#endregion Constructor

    //#region Public Methods
    public Save(otherBenefitsDto: OtherBenefitsDto): Observable<GenericMemberResponsePortalResponseDto<OtherBenefitsDto>>{
        return this.Post('/Survey/OtherBenefits', otherBenefitsDto);
    }
    //#endregion Public Methods
}
